import type { DeliveryProposalsInfoProps } from "@/pages/shipper-cargo-detail/ui/delivery-proposals-info";
import { MobileDeliveryProposalListItem } from "@/pages/shipper-cargo-detail/ui/mobile/delivery-proposal-list/delivery-proposal-list-item";
import { getDraftOfferCargoRows } from "@/pages/shipper-cargo-detail/ui/utils";
import { Stack } from "@mui/material";
import { useMemo } from "react";

type Props = DeliveryProposalsInfoProps;

export const MobileDeliveryProposalList: React.FC<Props> = ({
  offerCargoProcess,
}) => {
  const data = useMemo(
    () => getDraftOfferCargoRows(offerCargoProcess),
    [offerCargoProcess],
  );

  if (offerCargoProcess.status !== "success") {
    return null;
  }

  return (
    <Stack
      direction="column"
      gap={1}
      mx={-2}
      px={1}
      py={2}
      sx={{
        backgroundColor: "grey.50",
        border: "1px solid #E4E5E5",
        borderWidth: "1px 0",
      }}
    >
      {data.map((cargo) => (
        <MobileDeliveryProposalListItem
          key={cargo.id}
          id={cargo.id}
          companyName={cargo.companyName}
          deliveryProposalContractStatus={cargo.deliveryProposalContractStatus}
          proposedAt={cargo.proposedAt}
          responseDeadlineAt={cargo.responseDeadlineAt}
          requiredShippingFee={cargo.requiredShippingFee}
          proposedFeeDiff={cargo.proposedFeeDiff}
        />
      ))}
    </Stack>
  );
};
